import React from 'react'
import {
	RefundBlock,
	RefundSeparator,
	RefundStoreCreditBlockShippingOptionInfo,
	RefundSeparatorWrapper,
} from './../style'
import { useDispatch } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import { ButtonFull } from 'components/Form/Button'
import Instructions from 'components/InstructionList'
import RefundTotal from 'components/RefundTotal'
import PopupTitle from './PopupTitle'
import { SS } from 'utils/common'
import history from 'utils/history'
import { clearHandledItems } from 'components/Steps/thunk'
import { setRefundStateToDefault } from '../thunk'
import { Icon } from 'components/Icon'

const RefundFinalPopup = ({
	instructions = [],
	totals,
	currency = '',
	isShippingOptionSelected = false,
	shipmentOptionInStore = {
		selected: false,
	},
}) => {
	const dispatch = useDispatch()
	//let { refundTotal } = totals
	return (
		<RefundBlock>
			<PopupTitle green icon='checkRadial'>
				<FormattedMessage
					id='gcFinal.dialog.titleRefund'
					defaultMessage='Your refund is registered'
				/>
			</PopupTitle>

			<RefundSeparatorWrapper>
				<Icon component='RefundSeparator' />
			</RefundSeparatorWrapper>

			<Instructions items={instructions} />

			<RefundSeparator />

			{!!isShippingOptionSelected && (
				<RefundStoreCreditBlockShippingOptionInfo>
					<FormattedMessage
						id='shippingSelector.selectedOptionTitle'
						defaultMessage='Shipping option:'
					/>{' '}
					{shipmentOptionInStore.selected ? (
						<FormattedMessage
							id={`shippingSelector.options.names.${shipmentOptionInStore.type}`}
							defaultMessage=' '
						/>
					) : (
						<FormattedMessage
							id='shippingSelector.options.names.LABEL_BY_EMAIL'
							defaultMessage=' '
						/>
					)}
				</RefundStoreCreditBlockShippingOptionInfo>
			)}

			{/*<RefundStoreCreditBlock grey>
				<RefundStoreCreditBlockTitle>
					<FormattedMessage
						id='gcSuggestion.dialog.giftCard.title'
						defaultMessage='STORE CREDIT (VALID FOR 3 YEARS)'
					/>
				</RefundStoreCreditBlockTitle>
				<RefundStoreCreditBlockSum>
					{formatPrice(refundTotal, currency)}
				</RefundStoreCreditBlockSum>
				<RefundStoreCreditBlockDescription>
					<FormattedMessage
						id='gcSuggestion.dialog.giftCard.description'
						defaultMessage='Incl. free shipping for your returns'
					/>
				</RefundStoreCreditBlockDescription>
			</RefundStoreCreditBlock>*/}
			<RefundTotal totals={totals} currency={currency} />
			<ButtonFull
				dark
				w419
				onClick={() => {
					SS.remove('steps')
					dispatch(clearHandledItems())
					dispatch(setRefundStateToDefault())
					history.push('/orders')
				}}
			>
				<FormattedMessage
					id='gcFinal.dialog.gotIt'
					defaultMessage='GOT IT!'
				/>
			</ButtonFull>
		</RefundBlock>
	)
}

export default RefundFinalPopup
